import script from "./RightSidebarModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RightSidebarModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./RightSidebarModalComponent.vue?vue&type=style&index=0&id=03454970&lang=css"

const __exports__ = script;

export default __exports__